module.exports = __webpack_public_path__ + "static/media/icon.e49d4b25.svg";